 <template>
  <div class="Visage" :class="'is-' + face">
    <div ref="visage" class="Visage__face" @mousedown="onClick(face)">
      <img :src="require('./img/'+ face +'.png')" />
    </div>
    <div ref="container" class="Visage__container">
      <div class="Visage__angle"></div>
      <div ref="words"
      class="Jeu__word Visage__word" v-for="(w,k) in words"
      :key="k" @click="onChoice(face+k)"
      :style="selected(face+k, w)"
       @mouseover="tooltip = k"
       @mouseleave="tooltip = null"
       >
        <div style="pointer-events: none;">{{ trans(face+k + '_txt') }}</div>
        <transition name="Tooltip">
          <div v-if="tooltip == k" class="Tooltip">{{ trans(face+k + '_sentence') }}</div>
        </transition>
      </div>
    </div>
    <transition @enter="enterCount" @leave="leaveCount" mode="out-in">
      <div v-if="count > 0" class="Visage__count">{{ count }}</div>
    </transition>
  </div>
</template>

<script>
import Translations from './Visage-translation'

export default {
  name: 'Visage',
  props: ['face', 'words'],
  data: () => ({
    choices: [],
    image: '',
    count: 0,
    tooltip: null,
  }),
  translations: Translations,
  methods: {
    onClick(arg) {
      TweenMax.from(this.$refs.visage, 0.70, { scale: 1.50, ease: Power2.easeOut })
      this.$parent.dispatch({ evt:'onClicked', ref: arg })
    },
    onClicked(arg) {
      if(this.face === arg) {
        TweenMax.set(this.$el, { zIndex: 10 })
        TweenMax.set(this.$refs.container, { display: 'block', opacity: 0 })
        TweenMax.to(this.$refs.container, 0.5, { opacity: 1, ease: Power2.easeOut, delay: 0.20 })
        TweenMax.staggerFrom(this.$refs.words, 0.35, { alpha:0, y: 20, delay: 0.25 }, .1)
      } else {
        TweenMax.set(this.$refs.container, { display: 'none' })
        TweenMax.set(this.$el, { zIndex: 1 })
      }
    },
    onChoice(arg) {
      this.$parent.dispatch({ evt:'onChoiced', ref: arg })
    },
    onChoiced(arg) {
      this.choices = arg
      let nw = 0
      _.each(this.choices, (value)=> {
        if(value.split('')[0] === this.face)
          nw += 1
      })
      this.count = nw
    },
    setStyle(color) {
      return { backgroundColor: color }
    },
    selected(id, color) {
      let b = false
      _.each(this.choices, (value)=> {
        if(value === id)
          b = true
      })
      return { backgroundColor: b ? 'white' : color }
    },
    enterCount(el, done) {
      TweenMax.from(el, 0.25, { scale: 0.50, ease: Power2.easeOut, onComplete:()=>{ done() } })
    },
    leaveCount(el, done) {
      TweenMax.to(el, 0.25, { scale: 0, ease: Power2.easeOut, onComplete:()=>{ done() } })
    }
  },
}
</script>

<style lang="stylus">

@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Visage

  position relative
  margin 0 48px
  height 140px

  &.is-c
    .Visage__container
      top -120px
      border-radius 40px 40px 40px 0px
    .Visage__angle
      top 166px
      transform rotate(90deg)

  &__face
    position absolute
    width 95px
    height 121px
    color black
    cursor pointer

  &__angle
    position absolute
    width 0
    height 0
    border-right 30px solid rgba(0, 0, 0, 0.25)
    border-bottom 30px solid transparent
    left -30px
    top 0px

  &__container
    position absolute
    display none
    top 30px
    left 130px
    background-color rgba(0, 0, 0, 0.25)
    border-radius 0px 40px 40px 40px
    padding 10px 0px

  &__word
    width 130px
    height 40px
    cursor pointer
    text-align center
    text-transform upperCase
    font-size 13px
    font-weight 700
    padding-top 14px
    line-height 16px
    color black
    transition none
    margin 14px 20px
    border-radius 25px
    transition background 1s

    &:hover
      background-color white !important

    &.selected
      background-color white

  &__count
    position absolute
    text-align center
    line-height 32px
    font-size 16px
    font-weight 700
    width 30px
    height 30px
    background-color black
    border-radius 15px
    color white
    top -6px
    left 60px
</style>



// WEBPACK FOOTER //
// src/components/jeu2/Visage.vue